import { render, staticRenderFns } from "./promo.vue?vue&type=template&id=1845bf8e&"
import script from "./promo.vue?vue&type=script&lang=ts&"
export * from "./promo.vue?vue&type=script&lang=ts&"
import style0 from "./promo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports